import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import Modal from "react-bootstrap/Modal";

import { memo } from "react";
import React, { useEffect } from "react";

import { useLocalStorage } from "../../../../hooks/useLocalStorage";
import ButtonCard from "../../../atoms/buttons/ButtonCard";
import DataTable from "react-data-table-component";
import ConstantesTabla from "../../../../utils/ConstantesTabla";


registerLocale("es", es);

const ModalExclusionCentros = (object) => {
    const [token] = useLocalStorage("token", "");

    useEffect(() => { }, [token]);
    

    const columnas = [
        {
            name: (
                <div className="single-header">
                    Seleccione una opción
                </div>
            ),
            selector: (row) => (
                <div className="column-wrapper d-flex ">
                    {/* Columna 1 - Checkbox */}
                    <div className="checkExcl pe-3">
                        <input type="checkbox" />
                    </div>
                    {/* Columna 2 - Exclusion */}
                    <div className="exclusion">
                        {row?.exclusion}
                    </div>
                </div>
            ),
            // Se puede ajustar el ancho de la columna para que quepan ambas subcolumnas
           
        },
    ];

    function modalExclusionCentros() {
        return (
            <Modal
                className="infModal fechas z-index-1055"
                show={object.show}
                onHide={object.handleClose}
                backdrop="static"
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {/* <Titulo titulo={"Exclusiones"} tipo={"tituloModal"} /> */}
                        <h4 className="tituloModal">Exclusiones</h4>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="caja_formulario col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12">
                        <div className="contTabla mt-2 d-flex flex-column justify-content-center">
                            <div className="container tablacolumnasTablaSeleccionCentros card">
                                <DataTable
                                    className="table-responsive"
                                    columns={[...columnas]}
                                    data={object.exclusiones}
                                    pagination={false}
                                    paginationComponentOptions={ConstantesTabla.paginacionOpt}
                                    noDataComponent={<span>No se encontraron puestos</span>}
                                    customStyles={ConstantesTabla.customStyles}
                                    width="auto"
                                    fixedHeader

                                    subHeaderWrap={true}
                                    style={{ marginTop: "20px" }}
                                />
                            </div>
                        </div>
                    </div>

                    {" "}
                    <ButtonCard
                        id="btnCerrar"
                        clases="btn-card bg-danger mt-2"
                        nombre={"Cerrar"}
                        funcion={() => {
                            object.handleClose();
                        }}
                    />

                    <ButtonCard
                        id="btnAceptar"
                        clases="btn-card mt-2 rounded"
                        nombre={"Aceptar"}
                        funcion={() => {
                            object.handleClose();
                        }}
                    />


                </Modal.Body>
            </Modal>
        );
    }

    return <>{modalExclusionCentros()}</>;
};

export default memo(ModalExclusionCentros);
